export default __webpack_public_path__ + "static/media/collection-img-sample2@3x.c7f35260.png";